export function isAuthlessPath(pathname: string = window.location.pathname): boolean {
  return pathname.startsWith('/mail/a/');
}
